import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { ColorTypes, MenuEvent } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { BaseSidebar, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { MdmBrowserAdapter } from "../adapters";
import { AccountingRights } from "@reporting/rp-types/core";
import { MdmApplication } from "..";

@customElement('rp-mdm-sidebar')
export class Sidebar extends BaseSidebar<MdmApplication> {

	static styles = [...BaseSidebar.styles, style];

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: MdmBrowserAdapter;
    get browserAdapter() { 
        if (!this._browserAdapter) {
            this._browserAdapter = new MdmBrowserAdapter();
        }
        return this._browserAdapter;
    }

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.mdmBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			mdmBrowser: this.browser?.getState(),
		}
	}

	_onChangeState = () => {
		this.dispatchStateEvent();
	}
	
	refresh = () => {
		this.browser.refresh();
	}

	toggleCollapse = () => {
		this.browser.tree.toggleTreeCollapse();
	};

	_onNewMenuItemSelect = (e: MenuEvent) => {
		switch (e.item.key) {
			case 'newMdmTable':
				rp.host.openModalSidebar({ id: `mdm-tableDefForm-MDM`, caption: `${msg('New table')} - MDM` });
				break;
			case 'newSqlTable':
				rp.host.openModalSidebar({ id: `mdm-tableDefForm-SQL`, caption: `${msg('New table')} - SQL` });
				break;
		}
	}

	_onSelect = (e: BrowserEvent) => {
		rp.host.open(e.node.key, {title: e.node.value});
	}

	render = () => html`
		<div class="controls">
			<og-button
				icon="search"
				color="transparent"
				text="${msg('Search')}"
				style="flex: 1"
				@click="${() => rp.host.openCommands('MDM')}">
			</og-button>

			<og-button
				icon="arrows-rotate"
				title="${msg('Refresh')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.refresh()}">
			</og-button>

			<og-button
				icon="square-plus"
				title="${msg('Collapse/Expand tree')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.toggleCollapse()}">
			</og-button>

			${rp.userProvider.hasRight(AccountingRights.MDMDefine) ? html`
				<og-dropdown-menu
					noCaret
					dynamicWidth
					icon="plus"
					title="${msg('New')}"
					color="transparent"
					style="flex: 0 0 25px; text-align: center;"
					@menu.select="${this._onNewMenuItemSelect}"
					.items="${[
						{key: 'newMdmTable', value: `${msg('New table')} - MDM`, icon: 'table'},
						{key: 'newSqlTable', value: `${msg('New table')} - SQL`, icon: 'database'},
					]}">
				</og-dropdown-menu>
			` : ''}			
		</div>

		<div class="body">
			<rp-browser id="browser" .adapter="${this.browserAdapter}" @browser.select="${this._onSelect}"></rp-browser>
		</div>
	`;

}
